import Text from "@amzn/meridian/text";
import { useAppSelector } from "src/store/store";

const Unauthorized = () => {
  const { isAuthorized } = useAppSelector((state) => state.user);

  return (
    <div className="unauthorized">
      <Text type="b500">
        {!isAuthorized
          ? "Welcome to Safer. Please hang on while we are authenticating you..."
          : "Access is currently limited due to allowed/restricted group restrictions set by the safer owner. Please contact the service owner via SIM ticketing (CTI: WorkingWell / WorkingWell Program / Engineering)."}
      </Text>
    </div>
  );
};

export default Unauthorized;
